import * as React from 'react'
import { Box, Card, Typography, SxProps, Theme } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'
import { isolateNumber } from '@/utils/numberDirection'

export type WaterTreesCountCardProps = {
    value: number | string
    title?: string
    height?: number
    width?: number | string
    showcub?: boolean
    bgcolor?: string
    color?: string
    fontSize?: string | number
    unit?: string
    sx?: SxProps<Theme>
}

const WaterTreesCountCard: React.FC<WaterTreesCountCardProps> = ({
    value,
    title = "",
    height,
    width,
    showcub = false,
    bgcolor,
    color,
    fontSize,
    unit,
    sx
}) => {
    const { mode } = useAppTheme()
    const isDarkMode = mode === 'dark'
    
    // Light theme defaults for this specific design
    const bg = bgcolor || (isDarkMode ? '#202B40' : '#FFFFFF')
    const borderColor = isDarkMode ? 'rgba(255,255,255,0.08)' : '#EAEDF2'
    const textColor = color || (isDarkMode ? '#FFFFFF' : '#003F61')
    const labelColor = isDarkMode ? '#BBD7FF' : '#64748B'

    return (
        <Card
            elevation={0}
            sx={{
                width: width || '100%',
                height: height || 'auto',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: "8px", // Less rounded as requested
                border: bg === 'transparent' ? 'none' : `1px solid ${borderColor}`,
                bgcolor: bg,
                px: 2,
                py: 1.5,
                boxShadow: 'none',
                ...(Array.isArray(sx) ? sx : [sx])
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', gap: 0.5 }}>
                <Typography
                    sx={{
                        color: textColor,
                        fontSize: fontSize || (typeof value === 'number' ? 36 : 24),
                        fontWeight: 400,
                        lineHeight: 1,
                        fontFamily: 'Rubik, sans-serif',
                    }}
                >
                    {isolateNumber(value)}
                </Typography>
                {(showcub || unit) && (
                    <Typography
                        sx={{
                            color: textColor,
                            fontSize: 4,
                            fontWeight: 700,
                            fontFamily: 'Rubik, sans-serif',
                        }}
                    >
                        {unit || 'מ"ק'}
                    </Typography>
                )}
            </Box>

            {title && (
                <Typography
                    sx={{
                        color: labelColor,
                        fontSize: 16,
                        fontWeight: 700, // Bolder title
                        textAlign: 'center',
                        mt: 0.5,
                        fontFamily: 'Rubik, sans-serif',
                        textTransform: 'uppercase'
                    }}
                >
                    {title}
                </Typography>
            )}
        </Card>
    )
}

export default WaterTreesCountCard
